import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BarChartSeries } from './bar-chart-series';
import { LineChartSeries } from './line-chart-series';
import { AreaChartSeries } from './area-chart-series';
import { PieChartSeries } from './pie-chart-series';
import { RadarChartSeries } from './radar-chart-series';
import { ScatterChartSeries } from './scatter-chart-series';
import { BubbleChartSeries } from './bubble-chart-series';
import type { ChartSeries } from '.';

// eslint-disable-next-line complexity
export function getChartSeriesConstructorByType(chartType: SubChartType): typeof ChartSeries | undefined {
    switch (chartType) {
        case SubChartType.BarChart:
        case SubChartType.Bar3DChart:
            return BarChartSeries;
        case SubChartType.LineChart:
        case SubChartType.Line3DChart:
        case SubChartType.StockChart:
            return LineChartSeries;
        case SubChartType.AreaChart:
        case SubChartType.Area3DChart:
            return AreaChartSeries;
        case SubChartType.PieChart:
        case SubChartType.Pie3DChart:
        case SubChartType.OfPieChart:
        case SubChartType.DoughnutChart:
            return PieChartSeries;
        case SubChartType.RadarChart:
            return RadarChartSeries;
        case SubChartType.ScatterChart:
            return ScatterChartSeries;
        case SubChartType.BubbleChart:
            return BubbleChartSeries;
    }
}
